import React from "react";

const ArrowRight = ({
  height = 12,
  width = 32,
}: {
  height?: number;
  width?: number;
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
    >
      <line x1="0" y1="6" x2="26" y2="6" stroke="white" strokeWidth="2" />
      <polyline
        points="20,1 27,6 20,11"
        stroke="white"
        strokeWidth="2"
        fill="none"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default ArrowRight;
